<div class="attachments-section">
    <h2 class="attachments-title">Attachments</h2>

    @if (canModify()) {
        <div class="dropzone"
             [class.drag-over]="isDragOver()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)"
             (click)="fileInput.click()">
            <div class="dropzone-content">
                <svg class="upload-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                     stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                </svg>
                <span class="dropzone-text">Drag & drop your file here or click to upload</span>
                <span class="dropzone-hint">(Best with .zip, .json, or .png - other formats also supported)</span>
            </div>
            <input #fileInput type="file" multiple hidden (change)="onFileSelected($event)"/>
        </div>
    }

    @for (item of uploadQueue(); track item.file.name + $index) {
        <div class="file-card">
            <div class="file-card-top">
                <div class="file-thumbnail">
                    @if (item.previewUrl) {
                        <img [src]="item.previewUrl" alt="" class="thumbnail-img"/>
                    } @else {
                        <div class="extension-badge">
                            <span>.{{ item.file.name.split('.').pop() }}</span>
                        </div>
                    }
                </div>
                <div class="file-info">
                    <span class="file-name">{{ item.file.name }}</span>
                    <span class="file-size">{{ formatFileSize(item.file.size) }}</span>
                    <div class="progress-track">
                        <div class="progress-fill" [style.width.%]="item.progress"></div>
                    </div>
                </div>
            </div>
            <div class="file-actions upload-actions">
                <span class="progress-pct">{{ item.progress }}%</span>
            </div>
        </div>
    }

    @if (uploadQueue().length > 0 && attachments().length > 0) {
        <div class="separator"></div>
    }

    @for (attachment of attachments(); track attachment.id) {
        <div class="file-card" [class.deleted]="pendingDeletes().has(attachment.id)">
            <div class="file-card-top">
                <div class="file-thumbnail">
                    @if (isImage(attachment) && previewUrls().get(attachment.id)) {
                        <img [src]="previewUrls().get(attachment.id)" alt="" class="thumbnail-img"/>
                    } @else {
                        <div class="extension-badge"
                             [style.background]="getExtensionColor(attachment.fileExtension)">
                            <span>.{{ attachment.fileExtension }}</span>
                        </div>
                    }
                </div>
                <div class="file-info">
                    <span class="file-name" [title]="attachment.fileName">{{ attachment.fileName }}</span>
                    @if (!pendingDeletes().has(attachment.id)) {
                        <span class="file-size">{{ formatFileSize(attachment.fileSize) }}</span>
                    } @else {
                        <span class="deleted-label">File deleted.</span>
                    }
                </div>
            </div>
            <div class="file-actions">
                @if (pendingDeletes().has(attachment.id)) {
                    <button class="undo-btn" (click)="onUndoDelete(attachment.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="1 4 1 10 7 10"/>
                            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
                        </svg>
                        <span>Undo</span>
                    </button>
                } @else {
                    <button class="action-btn download-btn" (click)="onDownload(attachment)" title="Download">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="7 10 12 15 17 10"/>
                            <line x1="12" y1="15" x2="12" y2="3"/>
                        </svg>
                    </button>
                    @if (canModify()) {
                        <button class="action-btn delete-btn" (click)="onDelete(attachment)" title="Delete">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                 stroke-linejoin="round">
                                <polyline points="3 6 5 6 21 6"/>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                            </svg>
                        </button>
                    }
                }
            </div>
        </div>
    }

    @if (!isLoading() && attachments().length === 0 && uploadQueue().length === 0) {
        <div class="empty-state">
            <span>No attachments yet.</span>
        </div>
    }
</div>
